<div class="d-flex" *ngIf="routerText; else showIcon">
  <a *ngIf="shouldUseRouterLink; else customTextLink" 
     [routerLink]="routerLink" 
     [queryParams]="computedQueryParams">
    {{routerText}}
  </a>
  <ng-template #customTextLink>
    <a class="cursor-pointer" (click)="handleCustomAction()">
      {{routerText}}
    </a>
  </ng-template>
</div>

<ng-template #showIcon>
  <nb-icon class="m-auto cursor-pointer" 
           [status]="status"
           [icon]="icon"
           *ngIf="shouldUseRouterLink; else customIconLink"
           [routerLink]="routerLink"
           [queryParams]="computedQueryParams">
  </nb-icon>
  <ng-template #customIconLink>
    <nb-icon class="m-auto cursor-pointer" 
             [status]="status"
             [icon]="icon"
             (click)="handleCustomAction()">
    </nb-icon>
  </ng-template>
</ng-template>
